import apiClient from "../client/apiClient";
import { ENDPOINTS } from "../config/endpoints";
import { normalizeApiError } from "../utils/handleError";
import { unwrapApiResponse } from "../utils/unWrapApiResponse.js";

export const kycDigilockerUpdate = async (payload) => {
  try {
    const response = await apiClient.post(ENDPOINTS.DIGILOCKER_UPDATE, payload, {
      params: {
        source: "web_app",
      },
    });
    return unwrapApiResponse(response, {
      extract: "resultsRaw",
      fallbackMessage: "DigiLocker update failed",
    });
  } catch (error) {
    throw normalizeApiError(error);
  }
};
